export { AccommodationDetailTemplate } from './AccommodationDetailTemplate';
export type {
  AccommodationAlternativeItem,
  AccommodationDetailListItem,
  AccommodationUnavailableRecovery,
  AccommodationDetailTemplateProps,
} from './AccommodationDetailTemplate.types';
